import { useState } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';

type MovementPlacebetDataProps = {
	ticketsData: any;
	currency: string;
};

type Palinsest = {
	[key: string]: Array<any>;
};

const extractSystem = (system: string, ticket: any) => {
	const s: Array<any> = ticket.selections[system];
	const palinsests: Palinsest = {};
	const palinsestsIds: Array<string> = [];

	s.forEach((r: any, i: number) => {
		r.combination.forEach((c: any, ii: number) => {
			const pid: string = c.palimpsestId;
			if (palinsestsIds.indexOf(pid) === -1) {
				palinsests[pid] = [];
				palinsestsIds.push(pid);
			}

			palinsests[pid].push(c);
		});
	});

	return [palinsests, palinsestsIds];
};

const MovementPlacebetData: React.FC<MovementPlacebetDataProps> = ({ ticketsData, currency }) => {
	const [systems, setSystems] = useState(Object.keys(ticketsData.system));

	return (
		<div className="d-flex f-column">
			{systems.map((s, i) => {
				return (
					<div className="d-flex f-column bet-system" key={i}>
						<div>
							<strong>
								System-{s}: importo&nbsp;
								<FormattedNumber
									value={ticketsData.system[s]}
									style="currency"
									currency={currency}
								/>{' '}
							</strong>
						</div>
						<table>
							<thead>
								<tr className="ticket-event-data-header">
									<th>&nbsp;</th>
									<th className="event-market">Market</th>
									<th className="event-selection">
										<FormattedMessage id="selection" />
									</th>
									<th className="event-amount">
										<FormattedMessage id="amount" />
									</th>
									<th className="event-odds">
										<FormattedMessage id="odds" />
									</th>
									<th className="event-schedule">
										<FormattedMessage id="schedule" />
									</th>
								</tr>
							</thead>
							<tbody>
								{ticketsData.selections[s].map((c: any, ii: number) => {
									return c.combination.map((cc: any, iii: number) => {
										return (
											<tr key={`${ii}-${iii}`}>
												{iii == 0 && <td rowSpan={c.combination.length}>{ii + 1}</td>}
												<td className="event-market">{cc.market}</td>
												<td className="event-selection text-center">{cc.selection}</td>
												{iii == 0 && (
													<td
														className="event-amount text-center"
														rowSpan={c.combination.length}
													>
														<FormattedNumber
															value={
																parseFloat(ticketsData.system[s]) /
																ticketsData.selections[s].length
															}
															style="currency"
															currency={currency}
														/>
													</td>
												)}

												<td className="event-odds text-center">{cc.odds}</td>
												<td className="event-palinsest text-center">
													{cc.palimpsestId}/{cc.eventId}
												</td>
											</tr>
										);
									});
								})}
							</tbody>
						</table>
					</div>
				);
			})}
		</div>
	);
};

export default MovementPlacebetData;
